export const PlanningItemStatus = {
    TO_DO: 10,
    IN_PROGRESS: 20,
    FINISHED: 30
};